import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { ConfiguratorLoaderService } from '../configurator-loader.service';
import { LoaderService } from '@icc/b2b/sales-document';

@Component({
    selector: 'icc-b2b-configurator-container',
    templateUrl: './b2b-configurator-container.component.html',
    styleUrls: ['./b2b-configurator-container.component.scss'],
})
export class B2bConfiguratorContainerComponent implements OnInit {
    static crumbsSubject = new ReplaySubject<Record<string, any>>();
    @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

    private subscription: Subscription = null;

    constructor(
        private configuratorLoaderService: ConfiguratorLoaderService,
        private loaderService: LoaderService,
    ) {}

    ngOnInit(): void {
        this.loadComponent();
    }

    async loadComponent() {
        this.loaderService.setLoading();
        const moduleRef = await this.configuratorLoaderService.loadConfigurator();
        const factory = moduleRef.componentFactoryResolver.resolveComponentFactory(moduleRef.instance.rootComponent);
        const componentRef = this.container.createComponent(factory);

        this.subscription = moduleRef.instance.rootComponent.crumbsSubject.subscribe(data => {
            B2bConfiguratorContainerComponent.crumbsSubject.next(data);
        });
    }
}
